import React, { FC, useContext, useState } from 'react';

import { GlobalContext } from '../../store';
import {
  IAdminClubInvitationRequest,
  IAdminEventInvitationRequest
} from '../../store/admin/invitations/store';

import validators from '../../contrib/validations';
import Button from '../Button';
import Input from '../Input';
import { useRouteInfoState } from '../RouteInfo/Context/RouteInfo.context';
import AccordionCard from '../GroupInvitationAccordion/GroupInvitationAccordion';

interface IProps {
  buttonText?: string;
  className?: string;
  descriptionText?: string;
  headerText?: string;
  isGuest?: boolean;
  onSubmit?: () => void;
}

const AddPlayersCard: FC<IProps> = props => {
  const { isGuest, buttonText, headerText, descriptionText, className } = props;

  const {
    actions: { adminInvitations, notifications }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const [playerEmails, setPlayerEmails] = useState('');

  const onSubmit = async () => {
    const emailsArray = playerEmails.replace(' ', '').split(',');

    let invitations: IAdminClubInvitationRequest | IAdminEventInvitationRequest = {
      club: Number(clubId),
      emails: emailsArray
    };

    if (eventId) {
      invitations = { ...invitations, event: Number(eventId), isGuest: !!isGuest };
    }

    const response = await adminInvitations.create(invitations);

    if (response && response.errors) {
      await notifications.push({
        status: 'unread',
        text: response.errors.invitations.msg || 'Error',
        type: 'error'
      });
    } else {
      await notifications.push({
        status: 'unread',
        text: 'Invitations sent',
        type: 'success'
      });

      setPlayerEmails('');
    }
  };

  const onCancel = () => setPlayerEmails('');

  const onChange = (event: any) => setPlayerEmails(event.target.value);

  return (
    <AccordionCard
      title={headerText || `ADD A PLAYER WITH THEIR EMAIL ADDRESS`}
      sectionKey="CLUB_ROSTER.ADD_PLAYERS"
      className={className}
    >
      <p className="add-players-card__description override">
        {descriptionText ||
          `List player email addresses separated by a comma to invite a group of players.`}
      </p>

      <Input
        label=""
        type="text"
        id="player-emails"
        outlined={true}
        fullWidth={true}
        multiline={true}
        rowsMax={4}
        rows={4}
        value={playerEmails}
        onChange={onChange}
      />

      <div className="add-players-card__buttons">
        <Button
          id="add-players-submit"
          className={'add-players-button'}
          color="primary"
          disabled={!validators.emailsSeparatedByCommas(playerEmails)}
          onClick={onSubmit}
          type="button"
          variant="contained"
        >
          {buttonText || 'Add Players'}
        </Button>

        <Button
          className={'add-players-button'}
          color="primary"
          disabled={playerEmails === ''}
          onClick={onCancel}
          type="button"
        >
          Cancel
        </Button>
      </div>
    </AccordionCard>
  );
};

export { AddPlayersCard };
